import script from "./fw00_check_point_limit.vue?vue&type=script&setup=true&lang=js"
export * from "./fw00_check_point_limit.vue?vue&type=script&setup=true&lang=js"

import "./fw00_check_point_limit.vue?vue&type=style&index=0&id=c0076284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0076284"]])

export default __exports__